import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import imagelocation from '../../images/location.png';
import { framework  } from 'saffroncodejs';
import { Map, Marker,InfoWindow, GoogleApiWrapper } from 'google-maps-react';
var PageManager = framework.PageManager;

class MapView extends React.Component {
  myLocLat = 1;
  myLocLong = 1;
  infW = '';
  constructor(props) {
    super(props);
    var urlParams = PageManager.decodePageParams(props);
    this.lat = this.encodeParam(urlParams[0]);
    this.lon = this.encodeParam(urlParams[1]);
    this.name = this.encodeParam(urlParams[2]);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    // this.onMapClicked=this.onMapClicked.bind(this);
   
    this.state = {
      isLoading: true,
      currentLatitude: '',
      currentLongitude: '',
      index: '',
      

      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {}
    };

  }

  encodeParam(encodedId)
    {
        return encodedId;
    }
    componentWillReceiveProps(props)
    {
    var urlParams = PageManager.decodePageParams(props);
    this.lat = this.encodeParam(urlParams[0]);
    this.lon = this.encodeParam(urlParams[1]);
    this.name = this.encodeParam(urlParams[2]);
       
    }
//   loadDetail() {
//     Axios.get(BimeManager.etelaatshoab + "/Get/?" + BimeManager.makeGetBody({ kind: null, currentLongitude: this.state.currentLongitude, KindArray: ['202', '203', '204', '205', '206', '207'], currentLatitude: this.state.currentLatitude }))

//       .then((result) => {
//         console.log("result.data : ", JSON.stringify(result.data));

//         this.setState({ data: result.data, isLoading: false })

//       })
//       .catch((error) => { alert(error) })
//   }



  onMarkerClick(props, marker) {
    console.log('marker', marker)
    this.infW =
      <div style={{ maxWidth: 'auto', textAlign: 'center', fontFamily: 'BYekan' }}>
        <h6>{marker.title}</h6>
        <p style={{ color: '#b41e8e' }}>{marker.name}</p>

      </div>

    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }

  render() {
    return (

      <div>
        <Row>
          <Col sm="12" className="alignRight title">
            <h4>نمایش روی نقشه</h4>
          </Col>
        </Row>
        {
          <Container>
            <div className="map_container">
              <Map
                google={this.props.google}
                initialCenter={{
                  lat: this.lat,
                  lng: this.lon
                }}
                icon={{
                  url: imagelocation,
                }}
                zoom={14}

              >
              <Marker
                          
                          name={this.name}

                          position={{ lat: this.lat, lng: this.lon }}
                          icon={{
                            url: imagelocation,
                          }}
                          title={this.name}
                          onClick={this.onMarkerClick}
                />

               <InfoWindow
                  marker={this.state.activeMarker}
                  visible={this.state.showingInfoWindow}>
                  {this.infW}
                </InfoWindow>
                
              </Map>
            </div>


          </Container>}
      </div>
    );
  }
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyCEq1aaFxPd0t1j_8dTR2VRJeJp4cKKXaY"
})(MapView)


// WEBPACK FOOTER //
// ./src/components/ListView/MapView.js